import script from "./SharingModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharingModal.vue?vue&type=script&setup=true&lang=ts"

import "./SharingModal.vue?vue&type=style&index=0&id=7de541cd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7de541cd"]])

export default __exports__